import { EMPLOYEE_INVITES_API } from "../../../../Utilities/APIs/APIs"
import InviteEmployees from "../../AuthScreens/InviteEmployees/InviteEmployees"

function InviteProducers() {
    return (
        <InviteEmployees

            headingTitle={'Invited Producers'}
            createButtonTitle={'Producer Invite'}
            invitedEmployeesAPI={`${EMPLOYEE_INVITES_API}?level=producer`}
            inviteLevel={'producer'}

        />
    )
}

export default InviteProducers
